
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingresortneargondia() {



  const cardData =
  {
    keyword: ' Destination Wedding Resorts Near Gondia',
    heading:  'Woodland Escape: Destination Wedding Resorts Near Gondia ',
    headingDescription: 'Woodland Escape Resort is a spectacular choice among destination wedding resorts near Gondia, offering a gorgeous natural setting of lush forests, spacious lawns and tranquil open grounds where every ceremony—from engagement to sangeet to the main wedding—can unfold beautifully under nature’s canopy. With ample accommodation for guests, flexible indoor-outdoor event spaces, and a dedicated team that handles décor, catering and guest comfort, the resort ensures your wedding weekend becomes a seamless, elegant celebration. Couples and families will find the blend of rustic-chic charm, comfortable cottages and scenic photo-worthy spots ideal for creating lifelong memories. Whether you’re planning an intimate gathering or a grand affair, Woodland Escape Resort near Gondia offers the perfect backdrop for a destination wedding that combines peace, luxury and natural beauty.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Destination Wedding Resorts Near Gondia",
      "description": "Discover the best destination wedding resorts near Gondia offering luxurious venues, scenic settings, and complete wedding planning services for a memorable celebration."
    },
    {
      "name": "Gondia Wedding Venue Resort",
      "description": "Host your dream wedding at Gondia resorts with spacious halls, elegant décor, and well-maintained gardens for an unforgettable experience."
    },
    {
      "name": "Gondia Luxury Wedding Resort",
      "description": "Experience opulent wedding celebrations at Gondia luxury resorts featuring premium amenities, fine dining, and exceptional hospitality."
    },
    {
      "name": "Affordable Wedding Resort Gondia",
      "description": "Plan a beautiful and budget-friendly wedding at Gondia resorts with quality services, scenic surroundings, and hassle-free arrangements."
    },
    {
      "name": "Gondia Pre Wedding Shoot Resort",
      "description": "Choose Gondia resorts for pre-wedding shoots with picturesque landscapes, gardens, and waterfront locations perfect for romantic photography."
    },
    {
      "name": "Gondia Outdoor Wedding Resort",
      "description": "Celebrate your wedding outdoors at Gondia resorts with open lawns, floral decorations, and a natural ambiance for an enchanting ceremony."
    },
    {
      "name": "Gondia Riverside Wedding Resort",
      "description": "Enjoy a serene riverside wedding at Gondia resorts offering calm water views, beautiful backdrops, and ideal locations for memorable photos."
    },
    {
      "name": "Gondia Hill Wedding Resort",
      "description": "Host a hilltop wedding at Gondia resorts with panoramic views, cool breezes, and stunning natural surroundings for a unique celebration."
    },
    {
      "name": "Gondia Family Wedding Resort",
      "description": "Plan a family-friendly wedding at Gondia resorts with spacious accommodations, kid-friendly activities, and amenities for all guests."
    },
    {
      "name": "Gondia Resort Wedding Packages",
      "description": "Choose from curated wedding packages at Gondia resorts that include catering, decoration, accommodation, and event management for a hassle-free experience."
    },
    {
      "name": "Gondia Wedding Booking Online",
      "description": "Easily book your Gondia wedding resort online to secure your preferred date, venue, and services with convenience and confidence."
    },
    {
      "name": "Gondia Resort for Marriage",
      "description": "Host your marriage at Gondia resorts offering comprehensive facilities, elegant venues, and professional staff to make your day unforgettable."
    },
    {
      "name": "Gondia Wedding Hall Resort",
      "description": "Celebrate your wedding in stylish halls at Gondia resorts equipped with modern amenities, seating arrangements, and beautiful interiors."
    },
    {
      "name": "Gondia Marriage Destination Resort",
      "description": "Choose Gondia resorts as your marriage destination for a perfect blend of luxury, scenic beauty, and complete wedding services."
    },
    {
      "name": "Gondia Wedding Destination Packages",
      "description": "Explore wedding destination packages at Gondia resorts including venue, catering, decor, and accommodation for a seamless celebration."
    }
  ],
  "tableData": [
    ["- Destination Wedding Resorts Near Gondia", "- Gondia Wedding Venue Resort"],
    ["- Gondia Luxury Wedding Resort", "- Affordable Wedding Resort Gondia"],
    ["- Gondia Pre Wedding Shoot Resort", "- Gondia Outdoor Wedding Resort"],
    ["- Gondia Riverside Wedding Resort", "- Gondia Hill Wedding Resort"],
    ["- Gondia Family Wedding Resort", "- Gondia Resort Wedding Packages"],
    ["- Gondia Wedding Booking Online", "- Gondia Resort for Marriage"],
    ["- Gondia Wedding Hall Resort", "- Gondia Marriage Destination Resort"],
    ["- Gondia Wedding Destination Packages", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Destination Wedding Resort Near Gondia",
    "WhyChoosedescription": "Woodland Escape Resort offers a breathtaking setting for destination weddings near Gondia. Surrounded by verdant landscapes and serene nature, it provides a scenic and memorable backdrop for your big day."
  },
  {
    "WhyChooseheading": "Sprawling Lawns & Elegant Event Spaces",
    "WhyChoosedescription": "The resort features expansive lawns, elegant sit‑outs and event zones, ideal for wedding ceremonies, receptions and pre‑wedding functions — providing flexibility and grandeur in one place."
  },
  {
    "WhyChooseheading": "Accommodation for Guests On‑site",
    "WhyChoosedescription": "With comfortable lodging options available on‑site, Woodland Escape Resort ensures your guests can stay close by and enjoy the festivities without the hassle of travel between venues."
  },
  {
    "WhyChooseheading": "Customized Wedding Planning Support",
    "WhyChoosedescription": "The resort assists in planning and coordinating – from décor and catering to logistics and set‑up. This makes it easier to create a personalized, seamless wedding experience."
  },
  {
    "WhyChooseheading": "Delicious Multi‑Cuisine Catering",
    "WhyChoosedescription": "Enjoy premium catering with freshly prepared local and multi‑cuisine menus, crafted to delight your guests and complement your wedding celebrations."
  },
  {
    "WhyChooseheading": "Tranquil & Romantic Natural Ambience",
    "WhyChoosedescription": "Situated amidst nature, the resort’s tranquil ambiance enhances the romantic feel of a destination wedding. The greenery, open skies and nature sound‑scape add to the magic."
  },
  {
    "WhyChooseheading": "Easily Accessible from Gondia",
    "WhyChoosedescription": "Located within convenient drive of Gondia, Woodland Escape Resort offers the right balance of seclusion and accessibility — ideal for your destination wedding guests."
  }
]


























  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a destination wedding resort near Gondia?",
    answer: "Woodland Escape Resort is an ideal destination wedding resort near Gondia, offering sprawling green lawns, serene surroundings, and picturesque backdrops perfect for wedding ceremonies and celebrations."
  },
  {
    question: "How far is Woodland Escape Resort from Gondia city?",
    answer: "The resort is conveniently located within driving distance from Gondia, making it easy for guests to reach while providing a tranquil and beautiful setting for a memorable wedding."
  },
  {
    question: "What facilities does Woodland Escape Resort provide for destination weddings?",
    answer: "The resort offers spacious lawns for ceremonies, elegant décor options, accommodation for guests, catering services, and dedicated areas for pre-wedding and wedding events."
  },
  {
    question: "Is Woodland Escape Resort suitable for family and friends attending a wedding?",
    answer: "Yes! The resort is family-friendly and group-friendly, ensuring safe, comfortable, and spacious arrangements for all wedding guests."
  },
  {
    question: "Does Woodland Escape Resort offer catering and event management for weddings?",
    answer: "Absolutely. The resort provides customized catering options, refreshments, and event management support to make your wedding a seamless and unforgettable experience."
  },
  {
    question: "How can we book Woodland Escape Resort for a destination wedding near Gondia?",
    answer: "You can book by calling or WhatsApp messaging our reservations team, or by visiting the official website. Advance booking is highly recommended for wedding dates."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patil, Gondia",
    text: "We had our destination wedding at Woodland Escape Resort, and it was magical! The natural surroundings, beautiful lawns, and friendly staff made our wedding unforgettable. Highly recommended near Gondia."
  },
  {
    name: "Ms. Sneha & Mr. Rajesh, Gondia",
    text: "Woodland Escape Resort is perfect for a destination wedding! The space, greenery, and arrangements exceeded our expectations. Our guests loved it, and we couldn’t have asked for a better wedding venue near Gondia."
  }
];

























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Resorts Near Gondia",
  "image": "https://woodlandescape.com/assets/images/wedding-resort-gondia.jpg",
  "description": "Plan your dream wedding at the best destination wedding resorts near Gondia. Woodlandescape Resort offers luxury wedding venues, riverside locations, hill resorts, and complete wedding packages for an unforgettable celebration.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "85"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "99999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-resorts-gondia"
  }
};




  return (
    <div>
<Helmet>
  <title>Destination Wedding Resorts Near Gondia | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Celebrate your dream wedding at Woodlandescape Resort, the best destination wedding resort near Gondia. Luxury venues, hill and riverside locations, and complete wedding packages for a perfect celebration." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Resorts Near Gondia, Gondia Wedding Venue Resort, Gondia Luxury Wedding Resort, Affordable Wedding Resort Gondia, Gondia Pre Wedding Shoot Resort, Gondia Outdoor Wedding Resort, Gondia Riverside Wedding Resort, Gondia Hill Wedding Resort, Gondia Family Wedding Resort, Gondia Resort Wedding Packages, Gondia Wedding Booking Online, Gondia Resort for Marriage, Gondia Wedding Hall Resort, Gondia Marriage Destination Resort, Gondia Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/35.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingresortneargondia;